import axios from "axios";

const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': 'application/json' }
});

// Branch groups of a company. The server validates the company, the user's branches and (for changes) the
// manage_branch_groups role permission; the interface only hides actions, it is not the control.
export class BranchGroupsAPI {

    // Function to list the groups of a company. status: active (default), inactive or all
    static async getBranchGroups({ business_code, status = 'active', token }) {
        const res = await server(`/branch-groups?business_code=${encodeURIComponent(business_code)}&status=${encodeURIComponent(status)}`, {
            method: 'GET',
            headers: { 'x-access-token': token }
        });
        return res;
    }

    // Function to get one group
    static async getBranchGroup(id, token) {
        const res = await server(`/branch-groups/${encodeURIComponent(id)}`, {
            method: 'GET',
            headers: { 'x-access-token': token }
        });
        return res;
    }

    // Function to create a group: { business_code, name, branchoffice_codes }
    static async newBranchGroup(data, token) {
        const res = await server('/branch-groups', {
            method: 'POST',
            data,
            headers: { 'x-access-token': token }
        });
        return res;
    }

    // Function to update a group: { name?, branchoffice_codes?, status? }
    static async updateBranchGroup(id, data, token) {
        const res = await server(`/branch-groups/${encodeURIComponent(id)}`, {
            method: 'PUT',
            data,
            headers: { 'x-access-token': token }
        });
        return res;
    }

    // Function to deactivate a group (the group and its branches are kept)
    static async deactivateBranchGroup(id, token) {
        const res = await server(`/branch-groups/${encodeURIComponent(id)}`, {
            method: 'DELETE',
            headers: { 'x-access-token': token }
        });
        return res;
    }
}
